import React from "react"

import FieldMultiselect_Picker from "../../multiselect/render/picker"

export default class FieldTags_Picker extends FieldMultiselect_Picker {

    onOptionClick = (option:any, hidePopover: boolean) => {
        let currentOptions = this.state.currentOptions ? this.state.currentOptions.slice() : [];
        this.previousOptions = currentOptions;

        if (!!option.isAllValuesOption) {
            // all values option click
            currentOptions = null;
        } else {
            currentOptions = gd.utils.toggleArrayValue(currentOptions, option.value);
        }

        // clear outdated values (removed from options) if any from currentOptions
        let options = this.props.field.getOptions()?.slice()
        if (options) {
            const availableValues = _.map(options, option=>option.value)
            currentOptions = _.intersection(currentOptions, availableValues)
        }

        this.setState({
            currentOptions: currentOptions
        }, () => {
            this.props.onChange?.(currentOptions, hidePopover)
            if (hidePopover) {
                this.hidePopover()
            }
        })
    }
}

